import { GlFormRadioGroup } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { AI_CATALOG_TYPE_AGENT, AI_CATALOG_TYPE_THIRD_PARTY_FLOW } from 'ee/ai/catalog/constants';
export default {
    name: 'FormAgentType',
    components: {
        GlFormRadioGroup
    },
    props: {
        id: {
            type: String,
            required: false,
            default: null
        },
        value: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'input'
    ],
    agentTypes: [
        {
            value: AI_CATALOG_TYPE_AGENT,
            text: s__('AICatalog|Custom')
        },
        {
            value: AI_CATALOG_TYPE_THIRD_PARTY_FLOW,
            text: s__('AICatalog|External')
        }
    ]
};
